/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Launch_Deliverable_LabelInputs */

const en_how_we_work_launch_deliverable_label = /** @type {(inputs: How_We_Work_Launch_Deliverable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What comes with the system`)
};

const lv_how_we_work_launch_deliverable_label = /** @type {(inputs: How_We_Work_Launch_Deliverable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas nāk līdzi sistēmai`)
};

/**
* | output |
* | --- |
* | "What comes with the system" |
*
* @param {How_We_Work_Launch_Deliverable_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_launch_deliverable_label = /** @type {((inputs?: How_We_Work_Launch_Deliverable_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Launch_Deliverable_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_launch_deliverable_label(inputs)
	return en_how_we_work_launch_deliverable_label(inputs)
});